module.exports = __webpack_public_path__ + "vue_assets/img/img_setting_wondorousempires.407a094e.png";